import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import _ from 'underscore'

import DomClass from './../../../../../../../../../js/classes/Dom.js'

const DeliveryField = ({ property, field={}, handleChange }) => {
    const props = {
        className : `happy-order__input ${ field.isErrors ? ' happy-order__input_error' : '' }`,
        type : "text",
        defaultValue : property.DEFAULT_VALUE,
        onChange : handleChange.bind(this, property),
        placeholder : (property.IS_PHONE) ? '+7 (___) ___-__-__' : property.NAME
    },
    input = useRef(null)

    useEffect(() => {
        if (property.IS_PHONE) {
            if (input.current) {
                DomClass.setMask(input.current)
            }
        }
    }, [])
    
    return <div className={ `happy-order__delivery-property happy-order__delivery-property_${ property.CODE }` } data-code={ property.CODE }>
        <label className="happy-order__label">
            { property.NAME } { property.REQUIRED ? <span className="happy-order__label-required">*</span> : null }
        </label>

        { property.SETTINGS.MULTILINE ? <textarea ref={ input } { ...(_.omit(props, 'type')) }  />
        : <input ref={ input } { ...props } /> }
    </div>
}

export default DeliveryField